import { ThemeAPI } from '../src/themeAPI.ts';

const getSavedThemeLocal: typeof ThemeAPI.getSavedThemeLocal = ThemeAPI.getSavedThemeLocal;

export { getSavedThemeLocal };
